import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { 
    DropBoxContainer,
    StyledFormControl,
 } from './SelectInsurerDropBox.styles';

export default function SelectInsurerDropBox({onInsurerChange}) {
  const [insurers, setInsurers] = React.useState([]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.length <= 3) {
      setInsurers(value);
      onInsurerChange(value);
    }
  };

  return (
    <DropBoxContainer>
      <StyledFormControl fullWidth>
        <InputLabel id="insurer-select-label">Select Insurers (up to 3)</InputLabel>
        <Select
            labelId="insurer-select-label"
            id="insurer-select"
            multiple
            value={insurers}
            label="Select Insurers (up to 3)"
            onChange={handleChange}
            renderValue={(selected) => selected.join(', ')}
        >
            <MenuItem value="bryte">Bryte Life</MenuItem>
            <MenuItem value="cal">CAL</MenuItem>
            <MenuItem value="fnb">FNB</MenuItem>
            <MenuItem value="hollard">Hollard</MenuItem>
            <MenuItem value="oldmutual">Old Mutual</MenuItem>
        </Select>
        </StyledFormControl>
    </DropBoxContainer>
  );
}